import {
  Flex,
  Card,
  CardContent,
  Division,
  Heading,
  Paragraph,
  Button,
} from "@ir/ui";
import { PageContent } from "@src/presentation/components/Layout/common";
import "./Home.scss";
import { FullLogo } from "@src/presentation/components/common";
import { useAuth } from "@src/presentation/hooks/auth";

/**
 * Home Page - Presentation layer
 * Single Responsibility: Displays home page
 */
export const Home = () => {
  const auth = useAuth();
  return (
    <Flex
      align="center"
      justifyContent="center"
      style={{
        height: "100vh",
        // backgroundColor: "var(--body-background-color)",
      }}
      className="home-page-bg"
    >
      <PageContent>
        <Card className="m-4 bg-white">
          <CardContent className="p-6">
            <Division className="mb-5 text-center">
              <FullLogo />
            </Division>
            <Heading level={1} className="text-grey-700 font-bold mt-3">
              DM Admin Portal
            </Heading>
            <Paragraph className="text-grey-500 font-regular mb-6">
              Welcome to our DM Admin Portal
            </Paragraph>
            <Button
              onPress={async () => {
                await auth.login();
              }}
            >
              Login
            </Button>
          </CardContent>
        </Card>
      </PageContent>
    </Flex>
  );
};
